import { bindable } from 'aurelia-framework';

export class EssIconWarning {

    @bindable
    public warnings: string[] = [];

}
